import {Module} from "vuex"
import SubmissionCommentProvider from '~/providers/submissionCommentProvider'

interface IState {
  provider: SubmissionCommentProvider,
}

export default function (): Module<IState, {}> {
  return {
    namespaced: true,
    state: {
      provider: new SubmissionCommentProvider(),
    },
    mutations: {
      createSubmissionComment(state, { formSubmission, submissionComment }) {
        formSubmission.submission_comments.push(submissionComment)
      },
      updateSubmissionComment(state, { formSubmission, updatedSubmissionComment }) {
        const index = formSubmission.submission_comments.findIndex(submissionComment => submissionComment.id === updatedSubmissionComment.id)
        formSubmission.submission_comments.splice(index, 1, updatedSubmissionComment)
      },
      removeSubmissionComment(state, { formSubmission, deletedSubmissionComment }) {
        const index = formSubmission.submission_comments.findIndex(submissionComment => submissionComment.id === deletedSubmissionComment.id)
        formSubmission.submission_comments.splice(index, 1)
      },
    },
    actions: {
      async createSubmissionComment({ commit, state }, { formSubmission, submissionCommentJson }) {
        const [result] = await state.provider.add({ submission_comment: submissionCommentJson })
        const submissionComment = result.submission_comment

        commit('createSubmissionComment', { formSubmission, submissionComment: submissionComment })
        return submissionComment
      },
      async updateSubmissionComment({ commit, state }, { formSubmission, submissionComment, submissionCommentJson }) {
        const [result] = await state.provider.update(submissionComment.id, { submission_comment: submissionCommentJson })
        commit('updateSubmissionComment', { formSubmission, updatedSubmissionComment: result.submission_comment })
        return result
      },
      async destroySubmissionComment({ commit, state }, { formSubmission, submissionComment }) {
        const [result] = await state.provider.destroy(submissionComment.id)
        commit('removeSubmissionComment', { formSubmission, deletedSubmissionComment: result.submission_comment })
        return result
      },
    },
  }
}
